import { useNavigate } from "react-router-dom";
import { Utensils, Star, Sun, CreditCard } from "lucide-react";

const PRIMO_LOGO = "/logos/sandwich-logo.png";

const PRIMO_BG = "https://images.unsplash.com/photo-1509722747041-616f39b57569?w=800&h=600&fit=crop";
const REVIEW_BG = "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop";

// Lien d'avis direct Google (Place ID Primo) — ouvre la fenêtre des 5 étoiles
// pour un visiteur déjà connecté à Google (cas standard sur mobile).
const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJpwl6ZeYHBEgRViL9Khj4gIw";

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="fixed inset-0 bg-gradient-to-b from-amber-50 to-white flex flex-col"
      data-testid="home-page"
    >
      {/* Header */}
      <div className="flex items-center justify-center pt-8 pb-3">
        <img src={PRIMO_LOGO} alt="Primo" className="h-20 w-auto rounded-xl" data-testid="primo-logo" />
      </div>

      <p className="text-sm text-neutral-500 text-center px-4 mb-2 flex items-center justify-center gap-1">
        <Sun className="w-4 h-4 text-amber-500" />
        Bienvenue ! Installez-vous, on s'occupe de vous.
      </p>

      {/* Boutons centrés */}
      <div className="flex-1 flex flex-col items-center justify-center gap-4 px-4">
        {/* Carte Primo */}
        <button
          onClick={() => navigate("/primo")}
          className="relative w-full h-36 rounded-2xl overflow-hidden shadow-lg active:scale-[0.98] transition-transform"
          data-testid="primo-menu-btn"
        >
          <img src={PRIMO_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
            <Utensils className="w-7 h-7 mb-2" />
            <h2 className="text-3xl font-bold font-['Oswald']">Carte Primo</h2>
            <p className="text-xs uppercase tracking-wider opacity-80 mt-1">Sandwicherie</p>
          </div>
        </button>

        {/* Laissez-nous un avis */}
        <a
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-full h-36 rounded-2xl overflow-hidden shadow-lg active:scale-[0.98] transition-transform block"
          data-testid="review-btn"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-amber-500 to-amber-700" />
          <img src={REVIEW_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
            <div className="flex gap-1 mb-2">
              <Star className="w-6 h-6 fill-amber-400 text-amber-400" />
              <Star className="w-6 h-6 fill-amber-400 text-amber-400" />
              <Star className="w-6 h-6 fill-amber-400 text-amber-400" />
              <Star className="w-6 h-6 fill-amber-400 text-amber-400" />
              <Star className="w-6 h-6 fill-amber-400 text-amber-400" />
            </div>
            <h2 className="text-3xl font-bold font-['Oswald']">Laissez-nous un avis</h2>
            <p className="text-xs uppercase tracking-wider opacity-80 mt-1">Sur Google</p>
          </div>
        </a>
      </div>

      {/* Footer */}
      <div className="pb-6 pt-4 px-4">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-neutral-100 flex items-center justify-center gap-2">
          <CreditCard className="w-5 h-5 text-amber-600" />
          <p className="text-base font-semibold text-neutral-700">
            CB à partir de <span className="text-amber-600">10€</span>
          </p>
        </div>
      </div>
    </div>
  );
}
